export default __webpack_public_path__ + "static/media/logo-dark.786daf61.webp";